import React from "react";

export default function HelpFrequentlyAskedQuestions() {
  return (
    <div className="help__block">
      <i className="help__icon icon-question" />
      <p className="help__subject">
        Have a question?
        <br />
        <b>
          Check out our{" "}
          <a href="/ask.html" className="underline">
            FAQs
          </a>
        </b>
      </p>
    </div>
  );
}
